import { useTheme } from '@mui/material';
import { MinusCircle } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { useField } from 'formik';

import {
  MaskedField,
  SelectField,
  SelectOption,
  Spacer,
} from 'theSource/components';
import {
  PhoneNumberWrapperStyled,
  RemoveWrapperIconStyled,
  ActionsWrapperStyled,
} from './PhoneNumberFieldStyled';

interface PhoneNumberFieldProps {
  onDelete: (index: number) => void;
  getOptions: (callerType: string) => SelectOption[];
  index: number;
}

export const PhoneNumberField = ({
  onDelete,
  getOptions,
  index,
}: PhoneNumberFieldProps) => {
  const typeFieldName = `phones[${index}].type`;
  const phoneFieldName = `phones[${index}].phone`;

  const theme = useTheme();
  const { t } = useTranslation('pages.contacts');
  const { value: typeFieldValue } = useField({ name: typeFieldName })[0];

  const availableOptions = getOptions(typeFieldValue);
  const handleDelete = () => onDelete(index);

  return (
    <PhoneNumberWrapperStyled data-testid="phone-number-combo-field">
      <MaskedField
        variant="phone"
        maxLength={16}
        fullWidth
        label={t('phoneNumber')}
        name={phoneFieldName}
        id={phoneFieldName}
        placeholder="+1"
      />
      <Spacer width={3} />
      <ActionsWrapperStyled>
        <SelectField
          fullWidth
          label={t('type')}
          name={typeFieldName}
          id={typeFieldName}
          labelId="type-label"
          options={availableOptions ?? []}
        />
        <Spacer width={3} />
        <RemoveWrapperIconStyled onClick={handleDelete}>
          <MinusCircle
            size={24}
            color={theme.palette.error.main}
            weight="bold"
            alt=""
            data-testid="minus-icon"
          />
          <span className="sr-only">{t('common:remove')}</span>
        </RemoveWrapperIconStyled>
      </ActionsWrapperStyled>
    </PhoneNumberWrapperStyled>
  );
};
